import React, { Component } from 'react'
import { Box, Button, Form, FormField, TextInput, Text, Stack, Heading, Image } from 'grommet'
import Cookies from 'js-cookie'
import { FormClose, Google } from 'grommet-icons'
import { PageCard } from './components/Cards'
import { SplitterLine } from './components/Common'
import firebase from './libs/firebase'
import { LogoWithNoTagLine } from './Image'
import { linearGradient } from './libs/color'
import { MotionBox } from './components/Motion'
import { AnimatePresence } from 'framer-motion'

const stacks = {
  login: 0,
  signup: 1
}

export class Authenticate extends Component {
  loginFormRef = React.createRef()
  signupFormRef = React.createRef()

  state = {
    submitting: false,
    showStack: 0,
    previousStack: 0,
    resend: null
  }

  redirectAuth = (data) => {
    // this.setSubmitting(false)
    console.log(data)
    // we don't need to pass any data, listeners pick it up in Root component, just force the route to change
    // this.setStack(1)
    this.setState(
      (prevState) => ({ showStack: 1, previousStack: prevState.showStack }),
      () => {
        console.log('redirecting...auth')
        // setTimeout(() => {
        //   this.props.history.push('/')
        // }, 500)
      }
    )
  }
  login = (...args) => {
    if (this.state.showStack === 0) {
      this.loginFormRef.current.handleSubmit(...args)
    } else {
      this.setStack(0)
      this.setState({ resend: null })
    }
  }
  signup = (...args) => {
    if (this.state.showStack === 1) {
      this.signupFormRef.current.handleSubmit(...args)
    } else {
      this.setStack(1)
    }
  }
  emailAuth = async (email, password) => {
    this.setSubmitting(true)
    await firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION)
    firebase
      .auth()
      .signInWithEmailAndPassword(email, password)
      .then(this.redirectAuth)
      // .then((userCredential) => this.setUser(userCredential))
      .catch((e) => {
        this.setSubmitting(false)
        console.error('LOGIN FAILED...')
        const error = {
          response: {
            // errorCode: e.code,
            name: 'Login failed',
            message: e.message
            // email: e.email
          }
        }
        console.warn(error)
      })
  }
  googleAuth = async () => {
    this.setSubmitting(true)
    await firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION)
    const provider = new firebase.auth.GoogleAuthProvider()
    // provider.addScope('https://www.googleapis.com/auth/drive.metadata.readonly')
    firebase
      .auth()
      .signInWithPopup(provider)
      .then(this.redirectAuth)
      // .then((credentials) => this.setUser(credentials))
      .catch((e) => {
        this.setSubmitting(false)
        console.error('LOGIN FAILED...', e)
        const error = {
          response: {
            // errorCode: e.code,
            name: 'Login failed',
            message: e.message
            // email: e.email
          }
        }
        console.warn(error)
      })
  }
  authViaEmail = (e) => {
    const { email, password } = e.value
    this.emailAuth(email, password)
  }
  setStack = (stack) => {
    this.setState((prevState) => ({ showStack: stack, previousStack: prevState.showStack }))
  }

  setSubmitting = (value) => {
    this.setState({ submitting: value })
  }

  // setFormValue = (value) => {
  //   console.log(value)
  // }
  render() {
    const { showStack, previousStack, submitting, resend, formValues } = this.state
    const { match, demoMode } = this.props

    return (
      <Box fill align="center" justify="center" overflow="hidden" pad={{ bottom: 'medium' }}>
        {/*<LogoHeader />*/}
        <Stack interactiveChild={showStack} guidingChild={'last'} fill anchor={'center'}>
          <PageCard
            width={{ min: 'medium' }}
            pad={'large'}
            elevation={'xlarge'}
            background={'white'}
            round={'medium'}
            height={{ min: 'medium' }}
            show={showStack === stacks.login}
          >
            <Box gap="medium" pad={'medium'}>
              <Box pad={'small'} gap={'small'} align={'center'}>
                <Box width="150px" align={'start'} justify={'start'}>
                  {demoMode ? null : <LogoWithNoTagLine />}
                </Box>
                {/*<Text size="large" weight="bold" color={'mesh-green-2'}>*/}
                {/*  Ops Platform*/}
                {/*</Text>*/}
              </Box>
              <Button
                disabled={submitting}
                size="large"
                icon={<Google size={'medium'} />}
                label={'Google sign-in'}
                color={'light-4'}
                onClick={() => this.googleAuth()}
              />
              <SplitterLine text={'OR'} />
              <Form
                value={formValues}
                // onChange={(nextValue) => this.setFormValue(nextValue)}
                onSubmit={this.authViaEmail}
              >
                <FormField required name="email" htmlFor="text-input-email" label="E-mail">
                  <TextInput id="text-input-email" name="email" />
                </FormField>
                <FormField required name="password" htmlFor="text-input-password" label="Password">
                  <TextInput type="password" id="text-input-password" name="password" />
                </FormField>
                <Box pad={'medium'} />
                <Box
                  fill={'horizontal'}
                  align="center"
                  justify="center"
                  direction="row"
                  // pad={{ vertical: 'medium' }}
                >
                  <Button
                    disabled={submitting}
                    size="large"
                    fill={'horizontal'}
                    type="submit"
                    primary
                    label="Log in"
                  />
                </Box>
              </Form>
            </Box>
          </PageCard>

          <Box fill />
        </Stack>
      </Box>
    )
  }
}
